import { computed } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import * as vuelidateValidators from '@vuelidate/validators'
const helpers = vuelidateValidators.helpers

function getVuelidateValidator(rule) {
  // Transform model meta validation to vuelidate validations
  let validator = null
  const ruleArguments = rule.arguments || []
  if (rule.name.toLowerCase().indexOf('regex') !== -1) {
    const ruleRegex = ruleArguments.length >= 1 && ruleArguments[0]
    validator = helpers.regex(new RegExp(ruleRegex))
    validator = helpers.withParams({ type: 'regex' }, validator)
  } else {
    validator = vuelidateValidators[rule.name] || rule.validator
    if (ruleArguments.length) validator = validator(...ruleArguments)
  }
  return validator
}
export function getVuelidateValidationRules(fieldId, rules) {
  return (
    rules?.reduce((validations, rule) => {
      let validator = getVuelidateValidator(rule)
      // if (validator && rule.name === 'required') {
      //   validator = helpers.withMessage(`${fieldLabel} is mandatory`, validator)
      // } else
      if (validator && rule.error_message) {
        validator = helpers.withMessage(rule.error_message, validator)
      }
      validator = helpers.withParams({ fieldId }, validator)
      return { ...validations, [rule.name]: validator }
    }, {}) || {}
  )
}

export function useFieldValidation(
  fieldId,
  fieldRef,
  rawValidationRules,
  scope,
) {
  const fieldValidationRules = getVuelidateValidationRules(
    fieldId,
    rawValidationRules,
  )

  const v$ =
    // Do not create v$ if no validation rules
    // WE COULD REVISIT THIS, so that without validation rules, the
    // prent v$ is returned (v$ of type "Collector only"), with validation
    // happening in children... However, in such case calling
    // useVuelidate() in the parent is usually enough...
    (Object.keys(fieldValidationRules).length &&
      useVuelidate(
        { [fieldId]: fieldValidationRules },
        { [fieldId]: fieldRef },
        {
          // options
          ...(fieldId && { $registerAs: fieldId }),
          ...(scope && { $scope: scope }),
          $autoDirty: true,
        },
      )) ||
    null

  return {
    v$,
    ...useFieldValidationErrors(v$),
  }
}

export function useFieldValidationErrors(v$) {
  return {
    isInvalid: computed(() => v$?.value?.$invalid || false),
    oneError: computed(() => {
      let firstError = false
      if (v$?.value?.$errors?.length >= 1) firstError = v$?.value?.$errors[0]
      return firstError
    }),
  }
}
